import { DocumentServicesObject } from '@wix/document-services-types';
import { debounce } from 'lodash';
import { getViewStateRegistryValues } from '../store';
import { HostEventData } from './types';

const notifyViewStateApps = debounce(
  (documentServicesAPI: DocumentServicesObject) => {
    const viewStatesRegistryData = getViewStateRegistryValues();

    viewStatesRegistryData.forEach((viewState) => {
      documentServicesAPI.platform.livePreview.updateWidgetViewStateAfterRefresh(
        {
          appDefinitionId: viewState.appData.appDefinitionId,
          componentRef: viewState.componentRef,
          widgetViewState: { stateName: viewState.name, stateProps: {} },
        },
      );
    });
  },
  300,
);

export const appRefreshCompleted = (
  documentServicesAPI: DocumentServicesObject,
) => {
  notifyViewStateApps(documentServicesAPI);
};
